import React, { useEffect, useState } from 'react';
import qs from 'query-string';
//import $ from 'jquery';
import moment from 'moment';
import momentTZ from 'moment-timezone';

import ConfirmDialog from './ConfirmDialog';
import PagamentoDetalhes from './PagamentoDetalhes';
import DetalhesPagamento from './PagamentoDetalhes2';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import api from '../../../services/api';
import '../admin.scss';
import { Dropdown, Button, ButtonGroup } from 'react-bootstrap';
import loadingGif from '../../../img/loading-gif.gif';

import fileDownload from 'js-file-download';
import Pagination from '@material-ui/lab/Pagination';
import { X_FOWARD_HOST } from '../../../utils/env';
import styled from 'styled-components';

//import CanvasJSReact from '../../../utils/canvasjs.react';
//https://www.npmjs.com/package/jspdf

const Container = styled.div`
	
`;

const ModalStyle = styled.div`
	.modal-dialog{
		background:#000 !important;
	}
`

registerLocale('pt-BR', ptBR);

function Pagamento(props) {
	const pageLimit = 50;
	//const [pontoVendas, setPontoVendas] = useState([]);
	const [unidades, setUnidades] = useState([]);
	const [pagamentos, setPagamentos] = useState([]);
	const [params, setParams] = useState({});
	const [modalVisible, setModalVisible] = useState(false);
	const confirmDialog = React.createRef();

	const [paginaAtual, setPaginaAtual] = useState(1);

	const [pagamento, setPagamento] = useState();

	const [loading, setLoading] = useState(false);
	const [loadingUnidades, setLoadingUnidades] = useState(true);

	//const [printState, setPrintState] = useState(false);

	const [loadDownload, setLoadDownload] = useState(false);

	const [numeroDePaginas, setNumeroDePaginas] = useState(10);

	const [total, setTotal] = useState(0);

	const [valorTotal, setValorTotal] = useState(0);

	//const { CanvasJS } = CanvasJSReact;

	//const { CanvasJSChart } = CanvasJS;

	useEffect(() => {
		let now = moment().format('DD/MM/YYYY');
		let qparams = Object.assign(
			{
				q: '',
				//data_inicial: moment().toDate(),
				//data_final: moment().toDate(),
				pontovenda: '',
				tipo: '',
				status: '',
				pagina: '',
				data_inicial: now,
				data_final: now,
			},
			qs.parse(props.location.search)
		);
		getPagamentos(qparams);
		if (Object.keys(qparams).length) {
			if (qparams.data_inicial) {
				qparams.data_inicial = moment(
					qparams.data_inicial,
					'DD/MM/YYYY'
				).toDate();
			}
			if (qparams.data_final) {
				qparams.data_final = moment(qparams.data_final, 'DD/MM/YYYY').toDate();
			}
		}
		getUnidadesOption();
		setParams(qparams);
		//////console.log(qparams);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.location.search]);

	async function getPagamentosChangePage(newPage) {
		//var self = this;
		if (loading) return;

		//////console.log('iniciando');
		//////console.log(params);
		const { data_inicial, data_final, pontovenda, q, tipo } = params;
		const DIDia = data_inicial.getDate();
		const DIMes = data_inicial.getMonth() + 1;
		const DIAno = data_inicial.getFullYear();
		const DFDia = data_final.getDate();
		const DFMes = data_final.getMonth() + 1;
		const DFAno = data_final.getFullYear();
		setLoading(true);

		//////console.log(q);

		const offset = (newPage - 1) * pageLimit;
		setPaginaAtual(newPage);

		try {
			const { data, status } = await api.get(
				//'/admin/pagamento/json?q=&data_inicial=23%2F03%2F2021&data_final=23%2F03%2F2021&pontovenda=&tipo=&status=',
				`/admin/pagamento/json?q=${q}&data_inicial=${DIDia}%2F${DIMes}%2F${DIAno}&data_final=${DFDia}%2F${DFMes}%2F${DFAno}&pontovenda=${pontovenda}&tipo=${tipo}&status=${params.status}&limit=${pageLimit}&offset=${offset}`
			);
			//////console.log('reponse aqui');
			//////console.log(data);
			//////console.log(status);
			//console.log(data);

			if (status === 200) {
				if (data.pagamentos) {
					setPagamentos(data.pagamentos);
				} else {
					setPagamentos([]);
				}
				if (data.total) {
					setTotal(data.total);
					setValorTotal(data.valor || 0);
					setNumeroDePaginas(parseInt(data.total / pageLimit) + 1);
				} else {
					setTotal(0);
					setValorTotal(0);

					setNumeroDePaginas(1);
				}
			} else {
				alert('codigo ' + status);
			}
		} catch (error) {
			//////console.log(error);
			alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		setLoading(false);
	}

	async function getPagamentosFilter() {
		//var self = this;
		if (loading) return;

		//////console.log('iniciando');
		//////console.log(params);
		const { data_inicial, data_final, pontovenda, q, tipo } = params;
		const DIDia = data_inicial.getDate();
		const DIMes = data_inicial.getMonth() + 1;
		const DIAno = data_inicial.getFullYear();
		const DFDia = data_final.getDate();
		const DFMes = data_final.getMonth() + 1;
		const DFAno = data_final.getFullYear();
		setLoading(true);

		//////console.log(q);

		try {
			const { data, status } = await api.get(
				//'/admin/pagamento/json?q=&data_inicial=23%2F03%2F2021&data_final=23%2F03%2F2021&pontovenda=&tipo=&status=',
				`/admin/pagamento/json?q=${q}&data_inicial=${DIDia}%2F${DIMes}%2F${DIAno}&data_final=${DFDia}%2F${DFMes}%2F${DFAno}&pontovenda=${pontovenda}&tipo=${tipo}&status=${
					params.status
				}&limit=${pageLimit}&offset=${0}`
			);
			//////console.log('reponse aqui');
			//////console.log(data);
			//////console.log(status);
			//console.log(data);

			if (status === 200) {
				if (data.pagamentos) {
					setPagamentos(data.pagamentos);
					setPaginaAtual(1);
				} else {
					setPagamentos([]);
				}
				if (data.total) {
					setTotal(data.total);
					setValorTotal(data.valor || 0);

					setNumeroDePaginas(parseInt(data.total / pageLimit) + 1);
				} else {
					setTotal(0);
					setValorTotal(0);

					setNumeroDePaginas(1);
				}
			} else {
				//alert('codigo ' + status);
			}
		} catch (error) {
			//////console.log(error);
			//alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		setLoading(false);
	}

	async function getPagamentos(params) {
		//var self = this;
		//////console.log('iniciando');
		const data_i = params.data_inicial.split('/');
		const data_f = params.data_final.split('/');
		//////console.log(data_i);
		//////console.log(params.data_inicial);

		setLoading(true);

		const options = {
			withCredentials: true,
			headers: {
				'content-type': 'application/json',
				//'content-length': 89,
				'X-Forwarded-Host': X_FOWARD_HOST,
			},
		};

		try {
			const response = await api.get(
				//'/admin/pagamento/json?q=&data_inicial=23%2F03%2F2021&data_final=23%2F03%2F2021&pontovenda=&tipo=&status=',
				`/admin/pagamento/json?q=${params.q}&data_inicial=${data_i[0]}%2F${
					data_i[1]
				}%2F${data_i[2]}&data_final=${data_f[0]}%2F${data_f[1]}%2F${
					data_f[2]
				}&pontovenda=${params.pontovenda}&tipo=${params.tipo}&status=${
					params.status
				}&offset=${0}&limit=${pageLimit}`,
				options
			);
			//////console.log('reponse aqui');
			//////console.log(data);
			//////console.log(status);
			const { data, status } = response;
			//console.log(response);

			if (status === 200) {
				if (data.pagamentos) {
					setPagamentos(data.pagamentos);
					setPaginaAtual(1);
				} else {
					setPagamentos([]);
				}
				if (data.total) {
					setTotal(data.total);
					setValorTotal(data.valor || 0);

					setNumeroDePaginas(parseInt(data.total / pageLimit) + 1);
				} else {
					setTotal(0);
					setValorTotal(0);

					setNumeroDePaginas(1);
				}
			} else {
				//alert('codigo ' + status);
			}
		} catch (error) {
			//////console.log(error);
			//console.log('error: ' + error);
			//alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		setLoading(false);
	}
	/*
	function getPontoVendasOption() {
		//////console.log('Iniciando');
		//var self = this;
		return api.get('/admin/pagamento/json').then((response) => {
			//////console.log('reponse aqui');
			//////console.log(response.data);
			if (response.status === 200) {
				setPontoVendas(response.data);
				//self.setState({ pontovendas: response.data });
			}
		});
	}*/

	function getUnidadesOption() {
		//var self = this;
		setLoadingUnidades(true);
		//setState({ loading: true });
		api
			.get('/admin/unidade/json')
			.then(({ data, status }) => {
				if (status === 200) {
					if (data.unidades) {
						setUnidades(data.unidades);
					}
					setLoadingUnidades(false);
				}
			})
			.catch((error) => {
				if (error.response.status === 401) {
					window.location.reload(false);
				}
				//////console.log(err);
			});
		//var self = this;
	}

	function handleDatepicker(name, value) {
		const p = { ...params };
		//var params = this.state.params;
		p[name] = value;
		setParams({ ...p });
		/*this.setState({
			params: params,
		});*/
	}

	function handleInput(e) {
		var target = e.target;
		var name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		const p = { ...params };
		//var params = this.state.params;
		p[name] = value;
		setParams({ ...p });
		/*this.setState({
			params: params,
		});*/
	}

	function renderMoney(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	/*function calcTotal(pagamentos) {
		var total = 0;
		for (let i = 0; i < pagamentos.length; i++) {
			total = total + parseFloat(pagamentos[i].total);
		}
		return total;
	}*/

	const statuses = {
		0: 'Processando',
		1: 'Em andamento',
		2: 'Cancelado',
		3: 'Falha',
		4: 'Pendente',
		5: 'Processado',
		6: '',
		7: 'Conflito',
		8: 'Chargeback',
	};

	const colors = {
		0: 'dark',
		1: 'dark',
		2: 'danger',
		3: 'danger',
		4: 'success',
		5: 'success',
		6: 'dark',
		7: 'danger',
		8: 'danger',
	};
	//const { unidades, pagamentos, params } = this.state;
	let qparams = Object.assign({}, params);

	if (qparams.data_inicial) {
		qparams.data_inicial = moment(qparams.data_inicial, 'DD/MM/YYYY').format(
			'DD/MM/YYYY'
		);
	}
	if (qparams.data_final) {
		qparams.data_final = moment(qparams.data_final, 'DD/MM/YYYY').format(
			'DD/MM/YYYY'
		);
	}

	async function getRelatorio(formato) {
		let qparams = Object.assign({}, params);
		setLoadDownload(true);
		if (qparams.data_inicial) {
			qparams.data_inicial = moment(qparams.data_inicial, 'DD/MM/YYYY').format(
				'DD/MM/YYYY'
			);
		}
		if (qparams.data_final) {
			qparams.data_final = moment(qparams.data_final, 'DD/MM/YYYY').format(
				'DD/MM/YYYY'
			);
		}

		let qsx = qs.stringify(Object.assign({ formato: formato }, qparams));

		////console.log(qparams);
		//	//console.log(qsx);

		try {
			const response = await api.get('/admin/transacao/relatorio?' + qsx, {
				responseType: 'blob',
				headers: { Accept: 'application/pdf' },
			});
			//	//console.log(response);

			//	//console.log(response.data);

			if (response.data && response.status === 200) {
				if (formato === 'pdf') {
					//const url = URL.createObjectURL(response.data);
					//window.open(url);

					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);

					/*const blob = new Blob([response.data], { type: 'application/pdf' });
					if (blob) {
						const url = URL.createObjectURL(blob);
						window.open(url);
					}*/
				} else {
					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);
				}
			}
		} catch (error) {
			//alert('error: ' + error);
			if (error.response.status === 401) {
				window.location.reload(false);
			}
			setLoadDownload(false);
		}
	}

	//////console.log(qparams);

	//verificar https://github.com/diegomura/react-pdf https://react-pdf.org/
	//verificar https://blog.bitsrc.io/exporting-data-to-excel-with-react-6943d7775a92
	//https://www.npmjs.com/package/jspdf

	return (
		<Container className='Relatorio row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>Relatório de Pagamentos</h2>

				{pagamentos.length > 0 && !loading && (
					<Dropdown as={ButtonGroup}>
						<Button className='buttonSplit'>Exportar Relátorio</Button>

						{loadDownload ? (
							<Dropdown.Toggle
								style={{ color: 'transparent', fontSize: 0 }}
								className='buttonSplit'>
								<img className='loadingImg' src={loadingGif} alt='loading' />
							</Dropdown.Toggle>
						) : (
							<Dropdown.Toggle className='buttonSplit'></Dropdown.Toggle>
						)}

						<Dropdown.Menu>
							<Dropdown.Item
								onClick={async (e) => {
									e.preventDefault();

									getRelatorio('pdf');

									//RelatorioPDF();
									//handleShowPrint();

									/*const doc = (
									<RelatorioPDF
										pagamentos={pagamentos}
										datas={{
											dataini: params.data_inicial,
											datafim: params.data_final,
										}}
									/>
								);
								const asPdf = pdf([]); // {} is important, throws without an argument
								asPdf.updateContainer(doc);
								const blob = await asPdf.toBlob();
								fileDownload(blob, 'document.pdf');*/
								}}>
								{'PDF'}
							</Dropdown.Item>
							<Dropdown.Item
								onClick={(e) => {
									e.preventDefault();
									getRelatorio('xls');
								}}>
								{'XLS'}
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				)}
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					{
						<div className='card-body'>
							<div className='row'>
								<div className='col-md-12'></div>
							</div>

							<div>
								<form>
									<div className='row'>
										<div className='form-group col-md-6'>
											<label>Pesquisa</label>

											<input
												className='form-control'
												type='text'
												name='q'
												onChange={handleInput}
												placeholder='Nome do cliente, ATK ou UC'
												value={params.q}
											/>
										</div>
										<div className='form-group col-md-3'>
											<label>Data Inicial</label>
											<br />
											<DatePicker
												className='form-control'
												name='data_inicial'
												dateFormat='dd/MM/yyyy'
												selected={params.data_inicial}
												onChange={(e) => handleDatepicker('data_inicial', e)}
												locale='pt-BR'
												customInput={<InputMask mask='99/99/9999' />}
											/>
										</div>
										<div className='form-group col-md-3'>
											<label>Data Final</label>
											<br />
											<DatePicker
												className='form-control'
												name='data_final'
												dateFormat='dd/MM/yyyy'
												selected={params.data_final}
												onChange={(e) => handleDatepicker('data_final', e)}
												locale='pt-BR'
												customInput={<InputMask mask='99/99/9999' />}
											/>
										</div>
									</div>
									<div className='row'>
										<div className='form-group col-md-3'>
											<label>Unidade</label>
											<select
												className='form-control input-sm'
												name='unidade'
												value={params.unidade}
												onChange={handleInput}>
												<option value=''>Todos</option>
												{unidades.map((u) => (
													<option key={u.id} value={u.id}>
														{u.nome}
													</option>
												))}
											</select>
										</div>
										<div className='form-group col-md-3'>
											<label>Tipo</label>
											<select
												className='form-control input-sm'
												name='tipo'
												value={params.tipo}
												onChange={handleInput}>
												<option value=''>Todos</option>
												<option value='1'>Débito</option>
												<option value='2'>Crédito</option>
											</select>
										</div>
										<div className='form-group col-md-3'>
											<label>Situação</label>
											<select
												className='form-control input-sm'
												name='status'
												value={params.status}
												onChange={handleInput}>
												<option value='5'>Processado</option>
												<option value='4'>Pendente</option>
												<option value='1'>Em andamento</option>
												<option value='2'>Cancelado</option>
												<option value='3'>Falha</option>
												<option value='8'>Chargeback</option>
												<option value=''>Todos</option>
											</select>
										</div>
										{/*<div className='form-group col-md-3'>
											<label>Paginação</label>
											<select
												className='form-control input-sm'
												name='pagina'
												value={params.pagina}
												onChange={handleInput}>
												<option value='5'>5</option>
												<option value='10'>10</option>
												<option value='20'>20</option>
												<option value='50'>50</option>
												<option value='100'>100</option>
												{
													//<option value='8'>Chargeback</option>
												}
												<option value=''>Todos</option>
											</select>
											</div>*/}
										<div className='form-group col-md-3'>
											<br />
											<button
												onClick={(e) => {
													e.preventDefault();
													getPagamentosFilter();
													////////console.log(params)
												}}
												className='mt-2 btn btn-block btn-primary'>
												Filtrar
											</button>
										</div>
									</div>
								</form>
							</div>

							{pagamentos.length > 0 && (
								<div className='float-right pb-2'>
									Total de {total} ({renderMoney(valorTotal) || 'R$ 0.00'})
									pagamentos. {numeroDePaginas}
									{numeroDePaginas > 1 && !loading && (
										<Pagination
											className='float-right'
											shape='rounded'
											count={numeroDePaginas}
											siblingCount={2}
											boundaryCount={2}
											page={paginaAtual}
											onChange={(event, value) => {
												getPagamentosChangePage(value);
											}}
										/>
									)}
								</div>
							)}
							<div>
								<table className='table'>
									<thead>
										<tr>
											<th>Origem/Status</th>
											<th>Data</th>
											<th>UC/Cliente</th>
											<th>Total Pago</th>
											<th></th>
											<th></th>
										</tr>
									</thead>

									{loading || loadingUnidades ? (
										<tbody>
											<tr>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 160,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 160 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 200,
															//marginBottom: 10,
														}}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 50,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 300 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{ height: 17, maxWidth: 136 }}
														className='Skeleton'
													/>
												</td>
												{/*<td>
                                                    R$ {transacao.fatura} ({transacao.parcelas == null ? '1' : transacao.parcelas }x)
                                                </td>
                                                <td>{transacao.vencimento}</td> */}
												<td style={{ maxWidth: 150 }}>
													<div
														style={{ height: 31, maxWidth: 75 }}
														className='Skeleton'
													/>
												</td>
											</tr>
											<tr>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 160,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 160 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 200,
															//marginBottom: 10,
														}}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 50,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 300 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{ height: 17, maxWidth: 136 }}
														className='Skeleton'
													/>
												</td>
												{/*<td>
                                                    R$ {transacao.fatura} ({transacao.parcelas == null ? '1' : transacao.parcelas }x)
                                                </td>
                                                <td>{transacao.vencimento}</td> */}
												<td style={{ maxWidth: 150 }}>
													<div
														style={{ height: 31, maxWidth: 75 }}
														className='Skeleton'
													/>
												</td>
											</tr>{' '}
											<tr>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 160,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 160 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 200,
															//marginBottom: 10,
														}}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 50,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 300 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{ height: 17, maxWidth: 136 }}
														className='Skeleton'
													/>
												</td>
												{/*<td>
                                                    R$ {transacao.fatura} ({transacao.parcelas == null ? '1' : transacao.parcelas }x)
                                                </td>
                                                <td>{transacao.vencimento}</td> */}
												<td style={{ maxWidth: 150 }}>
													<div
														style={{ height: 31, maxWidth: 75 }}
														className='Skeleton'
													/>
												</td>
											</tr>{' '}
											<tr>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 160,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 160 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 200,
															//marginBottom: 10,
														}}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{
															height: 17,
															maxWidth: 50,
															marginBottom: 10,
														}}
														className='Skeleton'
													/>

													<div
														style={{ height: 17, maxWidth: 300 }}
														className='Skeleton'
													/>
												</td>
												<td>
													<div
														style={{ height: 17, maxWidth: 136 }}
														className='Skeleton'
													/>
												</td>
												{/*<td>
                                                    R$ {transacao.fatura} ({transacao.parcelas == null ? '1' : transacao.parcelas }x)
                                                </td>
                                                <td>{transacao.vencimento}</td> */}
												<td style={{ maxWidth: 150 }}>
													<div
														style={{ height: 31, maxWidth: 75 }}
														className='Skeleton'
													/>
												</td>
											</tr>
										</tbody>
									) : (
										<tbody>
											
											{/*<DetalhesPagamento
												elementId={'modalDetalhes'}
												pagamento={pagamento}
												modalVisible={modalVisible}
												setModalVisible={setModalVisible}
											/>*/}
											
											{<PagamentoDetalhes
												elementId={'modalDetalhes'}
												pagamento={pagamento}
												modalVisible={modalVisible}
												setModalVisible={setModalVisible}
											/>}
											{pagamentos.map((pagamento) => (
												<tr key={pagamento.id}>
													<td>
														<span>{pagamento.unidade.nome}</span>
														<br />
														<strong
															className={
																'text-' + colors[pagamento.status] || 'dark'
															}>
															{statuses[pagamento.status]}
														</strong>
													</td>
													<td>
														{momentTZ
															.tz(pagamento.cadastro, 'America/Sao_Paulo')
															.format('DD/MM/YYYY H:mm:ss')}
													</td>
													<td>
														{pagamento.uc}
														<br />
														{pagamento.cliente}
													</td>
													<td>{renderMoney(pagamento.total)}</td>
													{/*<td>
                                                    R$ {transacao.fatura} ({transacao.parcelas == null ? '1' : transacao.parcelas }x)
                                                </td>
                                                <td>{transacao.vencimento}</td> */}
													<td>
														<button
															onClick={() => {
																setPagamento(pagamento);
																setModalVisible(true);
															}}
															className='btn btn-sm btn-default border float-right'
															data-toggle='modal'
															data-target={'#modalDetalhes' + pagamento.id}>
															Detalhes
														</button>
													</td>
												</tr>
											))}
										</tbody>
									)}
									{/*printState && (
										<RelatorioPDF2
											pagamentos={pagamentos}
											datas={{
												dataini: params.data_inicial,
												datafim: params.data_final,
											}}
										/>
										)*/}
								</table>
								{numeroDePaginas > 1 && !loading && (
									<Pagination
										className='float-right'
										shape='rounded'
										count={numeroDePaginas}
										siblingCount={2}
										boundaryCount={2}
										page={paginaAtual}
										onChange={(event, value) => {
											getPagamentosChangePage(value);
										}}
									/>
								)}
							</div>
						</div>
					}
				</div>
			</div>
			<ConfirmDialog ref={confirmDialog} elementId='confirm-dialog' />
		</Container>
	);
}

export default Pagamento;
